import { PriceDto, ProductBasePrice } from '@eurogast/hub-client-typescript';
import { Big } from 'big.js';
import { UnitDefinition } from '@/services/ProductDeserializer';
import PriceService from '@/services/PriceService';

export abstract class NumberFormatter {
  public static formatPrice(num: number | Big): string {
    if (num instanceof Big) {
      num = Number(num.toFixed(2));
    }
    if (num !== null && !isNaN(num)) {
      return num.toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    }
    return '';
  }

  public static formatStorageAmount(amount: Big, storageUnit: UnitDefinition): string {
    let unitName = '';
    if (storageUnit && storageUnit.abbreviation) {
      unitName = storageUnit.abbreviation;
    }
    return amount.toString() + ' ' + unitName;
  }

  public static formatStoragePrice(price: PriceDto, storageUnit: UnitDefinition): string {
    const storagePrice: Big = PriceService.findFinalPrice(price, 1, storageUnit);
    if (!storagePrice) {
      return '';
    }
    const unitName = (storageUnit && storageUnit.abbreviation ? storageUnit.abbreviation : '');
    let result = NumberFormatter.formatPrice(storagePrice) + '*';
    if (unitName) {
      result += ' ' + unitName;
    }
    return result;
  }

  public static formatFillQuantity(num: number): string {
    if (num % 1 !== 0) {
      return num.toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    }
    return num.toLocaleString('de-DE', { maximumFractionDigits: 0 });
  }

  public static formatBasePriceString(
    basePriceDto: ProductBasePrice, price: PriceDto, storageUnit: UnitDefinition
  ): string {
    const basePriceComplete = basePriceDto && basePriceDto.refQuantity && basePriceDto.quantity && basePriceDto.refUnit;
    if (!basePriceComplete || !price) {
      return '';
    }
    const baseRatio = new Big(basePriceDto.refQuantity).div(basePriceDto.quantity);
    const basePrice = PriceService.findFinalPrice(price, baseRatio, storageUnit);
    return NumberFormatter.formatPrice(basePrice) + '*/' + basePriceDto.refUnit;
  }

  public static formatUVPPriceString(
    storageUnit: UnitDefinition, price: PriceDto
  ): string {
    if (storageUnit && storageUnit.abbreviation && price && price.uvp) {
      return NumberFormatter.formatPrice(price.uvp) + '*/' + storageUnit.abbreviation;
    }
    return '';
  }
}
